import { defineMessages } from 'react-intl'

const messages = defineMessages({
  name: {
    id: 'productCategory.name',
    description: 'Product Category Name',
    defaultMessage: 'Name',
  },
  hsHeading: {
    id: 'productCategory.hsHeading',
    description: 'HS Heading',
    defaultMessage: 'HS Heading',
  },
  hsSubheading: {
    id: 'productCategory.hsSubheading',
    description: 'HS Subheading',
    defaultMessage: 'HS Subheading',
  },
  hsCode: {
    id: 'productCategory.hsCode',
    description: 'HS Code',
    defaultMessage: 'HS Code',
  },
  hsLocalTariffs: {
    id: 'productCategory.hsLocalTariffs',
    description: 'HS Local Tariffs',
    defaultMessage: 'HS Local Tariffs',
  },
  description: {
    id: 'productCategory.description',
    description: 'Description',
    defaultMessage: 'Description',
  },
  country: {
    id: 'productCategory.country',
    description: 'Import Country',
    defaultMessage: 'Import Country',
  },
  tariff: {
    id: 'productCategory.tariff',
    description: 'Tariff',
    defaultMessage: 'Tariff (%)',
  },
  classificationCode: {
    id: 'productCategory.classificationCode',
    description: 'HS Local Classification Code (optional)',
    defaultMessage: 'HS Local Classification Code (optional)',
  },
  productCategory: {
    id: 'productCategory.productCategory',
    description: 'Product Category',
    defaultMessage: 'Product Category',
  },
  createEditProductCategory: {
    id: 'productCategory.createEditProductCategory',
    description: 'Create/Edit Product Category',
    defaultMessage: 'Create/Edit Product Category',
  },
  viewProductCategory: {
    id: 'productCategory.viewProductCategory',
    description: 'View Product Category',
    defaultMessage: 'View Product Category',
  },
  newProductCategory: {
    id: 'productCategory.newProductCategory',
    description: 'New Product Category',
    defaultMessage: 'New Product Category',
  },
  editLink: {
    id: 'productCategory.editLink',
    description: 'Edit',
    defaultMessage: 'Edit',
  },
  viewLink: {
    id: 'productCategory.viewLink',
    description: 'View',
    defaultMessage: 'View',
  },
  mainInfoTitle: {
    id: 'productCategory.mainInfoTitile',
    description: 'Main Information',
    defaultMessage: 'Main Information',
  },
  localTariffLbl: {
    id: 'productCategory.localTariffLbl',
    description: 'Local Tariff',
    defaultMessage: 'LOCAL TARIFF',
  },
  editTariffLbl: {
    id: 'productCategory.editTariffLbl',
    description: 'Add/Edit Tariff',
    defaultMessage: 'ADD/EDIT LOCAL TARIFF',
  },
  cancelBtn: {
    id: 'productCategory.cancelBtn',
    description: 'Cancel',
    defaultMessage: 'Cancel',
  },
  updateBtn: {
    id: 'productCategory.updateBtn',
    description: 'Update',
    defaultMessage: 'Update',
  },
  addBtn: {
    id: 'productCategory.addBtn',
    description: 'Add',
    defaultMessage: 'Add',
  },
  createProductDialogTitle: {
    id: 'productCategory.createProductDialogTitle',
    description: 'Create Product Category',
    defaultMessage: 'Create Product Category',
  },
  createProductDialogText: {
    id: 'productCategory.createProductDialogText',
    description: 'Create Product Category Text',
    defaultMessage:
      'You will not be able to change the HS Heading and HS Subheading of your Product Category after creation. Once set, this cannot be changed. Are you sure you wish to continue?',
  },
  confirmDialogYes: {
    id: 'productCategory.confirmDialogYes',
    description: 'Yes',
    defaultMessage: 'Yes',
  },
  confirmDialogNo: {
    id: 'productCategory.confirmDialogNo',
    description: 'No',
    defaultMessage: 'No',
  },
  customerLbl: {
    id: 'product.customerLbl',
    description: 'Customer',
    defaultMessage: 'Customer',
  },
  hsCodeDetailsTab: {
    id: 'productCategory.hsCodeDetailsTab',
    description: 'HS Code Details Tab',
    defaultMessage: 'HS CODE DETAILS',
  },
  temperatureTab: {
    id: 'productCategory.temperatureTab',
    description: 'Temperature Tab',
    defaultMessage: 'TEMPERATURE',
  },
  productCategoryCreated: {
    id: 'productCategory.created',
    description: 'Product Category Created Successfully',
    defaultMessage: 'Product category created successfully',
  },
  productCategoryUpdated: {
    id: 'productCategory.updated',
    description: 'Product Category Updated Successfully',
    defaultMessage: 'Product category updated successfully',
  },
  productCategoryNotCreated: {
    id: 'productCategory.notCreated',
    description: 'Product Category Not Created',
    defaultMessage: 'Failed to create product category',
  },
  productCategoryNotUpdated: {
    id: 'productCategory.notUpdated',
    description: 'Product Category Not Updated',
    defaultMessage: 'Failed to update product category',
  },
  inUse: {
    id: 'productCategory.inUse',
    description: 'In Use',
    defaultMessage: 'In Use',
  },
  productCategoryDeleted: {
    id: 'productCategory.deleted',
    description: 'Product Category Deleted',
    defaultMessage: 'Product category deleted successfully',
  },
  productCategoryNotDeleted: {
    id: 'productCategory.notDeleted',
    description: 'Product Category Not Deleted',
    defaultMessage: 'Failed to delete product category',
  },
  deleteProductCategoryTitle: {
    id: 'productCategory.deleteProductCategoryTitle',
    description: 'Delete Product Category',
    defaultMessage: 'Delete Product Category',
  },
  deleteProductCategoryDescription: {
    id: 'productCategory.deleteProductCategoryDescription',
    description: 'Are you sure you want to delete this product category?',
    defaultMessage: 'Are you sure you want to delete this product category?',
  },
  deleteBtn: {
    id: 'productCategory.deleteBtn',
    description: 'Delete',
    defaultMessage: 'Delete',
  },
})

export default messages
